export default "__VITE_ASSET__BtmDl1_c__"